/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export interface Alert {
  id?: number | string;
  type: string;
  message: string;
  title?: string;
  stay?: boolean;
  timer?: number;
}

/**
 * These are the same as underlying bootstrap alert style names
 */
export enum AlertType {
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Secondary = 'secondary',
}
